/* Casemira: calcul commun fiche et panier, décision Raphaël du 13/09/2026.
   Départ: jours ouvrés PL, coupure stricte 11h30 Europe/Paris.
   Transport: jours ouvrés de destination, à partir du lendemain du départ.
   Calendriers nationaux FR/DE/AT/IT/ES; NL: fermetures colis GLS publiées.
   03/10/2026, Italie et Espagne (faits donnés par Raphaël) : Italie 3 à 4 jours ouvrés
   après expédition (GLS), Espagne 4 à 6. Borne haute retenue (4 et 6), comme ailleurs.
   `byCountry` porte ces délais pour tout fournisseur qui n'a pas sa propre ligne ;
   Carpet Decor ne livre pas l'Espagne (l'Italie est livrée depuis le 09/10, voir plus bas),
   Rezas n'est pas vendu en Italie : la valeur n'y sert pas. Fériés : seuls les jours NATIONAUX (pas les fêtes régionales
   ni patronales). Un pays de plus = une entrée dans byCountry, fixed et movable.
   Les exceptions régionales et fermetures propres aux entrepôts ne sont pas connues.
   04/10/2026, Tchéquie, Slovaquie, Danemark, Portugal (décisions de Raphaël du 03/10) :
   CZ et SK 2 à 3 jours ouvrés après expédition, DK 3 à 4, PT continental 6 à 8
   (hypothèse). Borne haute : CZ 3, SK 3, DK 4, PT 8. Fériés nationaux :
   CZ 1/1, 1/5, 8/5, 5/7, 6/7, 28/9, 28/10, 17/11, 24-26/12, Vendredi saint, lundi de Pâques ;
   SK 1/1, 6/1, 1/5, 8/5, 5/7, 29/8, 1/9, 15/9, 1/11, 17/11, 24-26/12, Vendredi saint,
   lundi de Pâques (1/9 et 17/11 gardés par prudence : leur statut de jour chômé a été
   remis en cause par les lois de consolidation, à vérifier ; un férié de trop retarde
   la date promise, il ne la rend jamais fausse) ;
   DK 1/1, 5/6 (Grundlovsdag, chômé en pratique), 25-26/12, Jeudi et Vendredi saints,
   lundi de Pâques, Ascension, lundi de Pentecôte (Store Bededag supprimé depuis 2024) ;
   PT 1/1, 25/4, 1/5, 10/6, 15/8, 5/10, 1/11, 1/12, 8/12, 25/12, Vendredi saint,
   Fête-Dieu (Pâques + 60).
   04/10/2026 (11h), Hongrie : 2 à 4 jours ouvrés, borne haute HU 4. Fériés : 1/1, 15/3, 1/5,
   20/8, 23/10, 1/11, 24-26/12, Vendredi saint, lundi de Pâques, lundi de Pentecôte (24/12 chômé
   depuis 2025 ; ponts ministériels annuels non connus).
   04/10/2026 (15h), Croatie et Roumanie (rapports marches/langues/hr et ro de la fenêtre 2) :
   HR 3 à 5 jours ouvrés après expédition (GLS), borne haute HR 5 ; RO 4 à 6, borne haute RO 6.
   Fériés HR : 1/1, 6/1, 1/5, 30/5, 22/6, 5/8, 15/8, 1/11, 18/11, 25/12, 26/12, lundi de
   Pâques, Fête-Dieu (Pâques + 60). Fériés RO : 1/1, 2/1, 6/1, 7/1, 24/1, 1/5, 1/6, 15/8,
   30/11, 1/12, 25/12, 26/12, et les fêtes mobiles ORTHODOXES : Vendredi saint, Pâques, lundi
   de Pâques, Pentecôte, lundi de Pentecôte (Pâques orthodoxe 12/4/2026, 2/5/2027 : calcul
   julien + 13 jours, juste de 1900 à 2099 ; `orthodox` ci-dessous).
   04/10/2026 (22h), Suède, Finlande, Grèce (rapports marches/langues/sv, fi, el de la fenêtre 2) :
   SE 4 à 6 jours ouvrés, borne haute SE 6 ; FI 5 à 7, borne haute FI 7 ; GR 6 à 8, borne haute
   GR 8 (îles : aucune promesse particulière). Fériés SE : 1/1, 6/1, 1/5, 6/6, 24/12, 25/12,
   26/12, 31/12, Vendredi saint, lundi de Pâques, Ascension, veille de la Saint-Jean (vendredi
   du 19 au 25 juin) ; Toussaint suédoise toujours un samedi (sans effet). Fériés FI : 1/1, 6/1,
   1/5, 6/12, 24/12, 25/12, 26/12, Vendredi saint, lundi de Pâques, Ascension, veille de la
   Saint-Jean (vendredi du 19 au 25 juin ; le jour de la Saint-Jean est un samedi). Fériés GR :
   1/1, 6/1, 25/3, 1/5, 15/8, 28/10, 25/12, 26/12 et les fêtes mobiles ORTHODOXES : lundi pur
   (Pâques - 48), Vendredi saint, lundi de Pâques, lundi de Pentecôte (Pâques + 50). Le 1/5
   grec est déplacé par décret quand il tombe dans la Semaine sainte (2027 : 1/5 = samedi
   saint) ; ce report n'est pas connu d'avance, il n'est pas modélisé.
   05/10/2026, délais réels Dywanopol (go de Raphaël 19h31, rapport 22-TARIFS-REELS-DYWANOPOL § 8) :
   PT continental 4 à 5 jours ouvrés après expédition (était 6 à 8), borne haute PT 5 ;
   RO 3 à 4 (était 4 à 6), borne haute RO 4 ; HR 3 à 4 (était 3 à 5), borne haute HR 4 ;
   FI 4 à 6 (était 5 à 7), borne haute FI 6. Les mentions plus haut sont l'historique.
   06/10/2026, vague D (rapports marches/langues/bg et sl) : BG 5 à 7 jours ouvrés après
   expédition, borne haute BG 7 ; SI 3 à 4, borne haute SI 4. Fériés BG : 1/1, 3/3, 1/5, 6/5,
   24/5, 6/9, 22/9, 24/12, 25/12, 26/12 et les fêtes mobiles ORTHODOXES (Vendredi saint, samedi
   saint, Pâques, lundi de Pâques) ; un férié FIXE qui tombe un samedi ou un dimanche est reporté
   au premier jour ouvré suivant (Code du travail, art. 154 ; pas les fêtes de Pâques). Fériés SI :
   1/1, 2/1, 8/2, 27/4, 1/5, 2/5, 25/6, 15/8, 31/10, 1/11, 25/12, 26/12, lundi de Pâques,
   Pentecôte (dimanche) ; pas de report en Slovénie. LV 3 à 5, borne haute LV 5 ; fériés LV :
   1/1, Vendredi saint, lundi de Pâques, 1/5, 4/5, 23/6, 24/6, 18/11, 24/12, 25/12, 26/12, 31/12 ;
   le 4/5 et le 18/11 tombés un week-end donnent le lundi suivant (fête des mères non fériée). EE 4 à 6,
   borne haute EE 6 ; fériés EE : 1/1, 24/2, Vendredi saint, Pâques, 1/5, Pentecôte, 23/6, 24/6, 20/8,
   24/12, 25/12, 26/12 ; pas de report. LT 3 à 4, borne haute LT 4 ; fériés LT : 1/1, 16/2, 11/3, Pâques et
   lundi de Pâques, 1/5, 24/6, 6/7, 15/8, 1/11, 2/11, 24/12, 25/12, 26/12 (fêtes des mères et des pères : des
   dimanches, sans effet) ; pas de report.
   11/10/2026, Carpet Decor (marches/langues/OUVERTURE-CARPET-DECOR-2026-10-09.md § 5) : l'Italie
   est livrée depuis le 09/10 ; délais CD en jours ouvrés après expédition IT, HR, SI, PT, FI 3 à 5,
   BG 3 à 5, GR 4 à 6. Borne haute dans `rates.carpetdecor` : IT 5, HR 5, SI 5, PT 5, FI 5, GR 6, BG 5.
   Sources et limites: README du lot delivery-2026-09-13. */
(function () {
  'use strict';
  if (window.CasemiraDelivery) return;
  const DAY = 86400000;
  const rates = { dywanopol: { DE: 2, AT: 3, NL: 3 }, carpetdecor: { DE: 3, AT: 3, NL: 3, IT: 5, HR: 5, SI: 5, PT: 5, FI: 5, GR: 6, BG: 5 }, rezas: { DE: 3, AT: 3, NL: 3 } };  // Rezas aligné sur le standard du site (Raphaël 30/09)
  const byCountry = { IT: 4, ES: 6, CZ: 3, SK: 3, DK: 4, PT: 5, HU: 4, HR: 4, RO: 4, SE: 6, FI: 6, GR: 8, BG: 7, SI: 4, LV: 5, EE: 6, LT: 4 };
  const fixed = {
    PL: [[1,1],[1,6],[5,1],[5,3],[8,15],[11,1],[11,11],[12,25],[12,26]],
    FR: [[1,1],[5,1],[5,8],[7,14],[8,15],[11,1],[11,11],[12,25]],
    DE: [[1,1],[5,1],[10,3],[12,25],[12,26]],
    AT: [[1,1],[1,6],[5,1],[8,15],[10,26],[11,1],[12,8],[12,25],[12,26]],
    NL: [[1,1],[12,25],[12,26]],
    IT: [[1,1],[1,6],[4,25],[5,1],[6,2],[8,15],[11,1],[12,8],[12,25],[12,26]],
    ES: [[1,1],[1,6],[5,1],[8,15],[10,12],[11,1],[12,6],[12,8],[12,25]],
    CZ: [[1,1],[5,1],[5,8],[7,5],[7,6],[9,28],[10,28],[11,17],[12,24],[12,25],[12,26]],
    SK: [[1,1],[1,6],[5,1],[5,8],[7,5],[8,29],[9,1],[9,15],[11,1],[11,17],[12,24],[12,25],[12,26]],
    DK: [[1,1],[6,5],[12,25],[12,26]],
    PT: [[1,1],[4,25],[5,1],[6,10],[8,15],[10,5],[11,1],[12,1],[12,8],[12,25]],
    HU: [[1,1],[3,15],[5,1],[8,20],[10,23],[11,1],[12,24],[12,25],[12,26]],
    HR: [[1,1],[1,6],[5,1],[5,30],[6,22],[8,5],[8,15],[11,1],[11,18],[12,25],[12,26]],
    RO: [[1,1],[1,2],[1,6],[1,7],[1,24],[5,1],[6,1],[8,15],[11,30],[12,1],[12,25],[12,26]],
    SE: [[1,1],[1,6],[5,1],[6,6],[12,24],[12,25],[12,26],[12,31]],
    FI: [[1,1],[1,6],[5,1],[12,6],[12,24],[12,25],[12,26]],
    GR: [[1,1],[1,6],[3,25],[5,1],[8,15],[10,28],[12,25],[12,26]],
    BG: [[1,1],[3,3],[5,1],[5,6],[5,24],[9,6],[9,22],[12,24],[12,25],[12,26]],
    SI: [[1,1],[1,2],[2,8],[4,27],[5,1],[5,2],[6,25],[8,15],[10,31],[11,1],[12,25],[12,26]],
    LV: [[1,1],[5,1],[5,4],[6,23],[6,24],[11,18],[12,24],[12,25],[12,26],[12,31]],
    EE: [[1,1],[2,24],[5,1],[6,23],[6,24],[8,20],[12,24],[12,25],[12,26]],
    LT: [[1,1],[2,16],[3,11],[5,1],[6,24],[7,6],[8,15],[11,1],[11,2],[12,24],[12,25],[12,26]]
  };
  // IT : lundi de Pâques (+1) ; ES : Vendredi saint (-2), seul jour mobile national.
  // CZ, SK : Vendredi saint (-2), lundi de Pâques (+1) ; DK : Jeudi saint (-3), Vendredi
  // saint (-2), lundi de Pâques (+1), Ascension (+39), lundi de Pentecôte (+50) ;
  // PT : Vendredi saint (-2), Fête-Dieu (+60).
  const movable = { PL: [1,60], FR: [1,39,50], DE: [-2,1,39,50], AT: [1,39,50,60], NL: [1,39,50], IT: [1], ES: [-2],
    CZ: [-2,1], SK: [-2,1], DK: [-3,-2,1,39,50], PT: [-2,60], HU: [-2,1,50], HR: [1,60], RO: [-2,0,1,49,50],
    SE: [-2,1,39], FI: [-2,1,39], GR: [-48,-2,0,1,50], BG: [-2,-1,0,1], SI: [1,49], LV: [-2,1], EE: [-2,0,49], LT: [0,1] };
  // Pays dont les fêtes mobiles suivent la Pâque orthodoxe (offsets de `movable` comptés depuis elle).
  const orthodox = { RO: true, GR: true, BG: true };
  // Pays qui reportent au premier jour ouvré suivant un férié FIXE tombé un week-end.
  const report = { BG: true };
  // Lettonie : seuls le 4/5 et le 18/11 tombés un samedi ou un dimanche donnent le lundi suivant.
  const reportLundi = { LV: [[5,4],[11,18]] };
  const holidays = new Map();
  const clock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const countryCode = value => String(value || 'FR').trim().toUpperCase();
  const supplier = value => String(value || '').trim().toLowerCase().replace(/[\s-]/g, '');

  function transitDays(country, vendor) {
    const key = supplier(vendor);
    const row = Object.prototype.hasOwnProperty.call(rates, key) ? rates[key] : null;
    const code = countryCode(country);
    if (row && Object.prototype.hasOwnProperty.call(row, code)) return row[code];
    return Object.prototype.hasOwnProperty.call(byCountry, code) ? byCountry[code] : 4;
  }

  function easter(year) {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4;
    const f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30;
    const i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
    return Date.UTC(year, Math.floor((h+l-7*m+114)/31)-1, (h+l-7*m+114)%31+1);
  }

  // Pâque orthodoxe (Meeus, calendrier julien) ramenée au grégorien : + 13 jours de 1900 à 2099.
  function orthodoxEaster(year) {
    const a=year%4,b=year%7,c=year%19,d=(19*c+15)%30,e=(2*a+4*b-d+34)%7;
    const month=Math.floor((d+e+114)/31),day=(d+e+114)%31+1;
    return Date.UTC(year, month-1, day) + 13*DAY;
  }

  // Les Date de calendrier sont en UTC; aucune opération dans le fuseau du navigateur.
  function businessDay(day, country) {
    const date = new Date(day);
    if (date.getUTCDay() === 0 || date.getUTCDay() === 6) return false;
    const code = Object.prototype.hasOwnProperty.call(fixed, country) ? country : 'PL';
    const year = date.getUTCFullYear();
    const key = code + year;
    if (!holidays.has(key)) {
      const dates = new Set();
      for (const [month, dayOfMonth] of fixed[code]) dates.add(Date.UTC(year, month-1, dayOfMonth));
      const paques = orthodox[code] ? orthodoxEaster(year) : easter(year);
      for (const offset of movable[code]) dates.add(paques + offset*DAY);
      if (report[code]) {
        // Report bulgare : chaque férié fixe tombé un samedi ou un dimanche donne le premier jour
        // ouvré suivant qui n'est pas déjà férié (24-26/12 sur un week-end : deux jours reportés).
        for (const [month, dayOfMonth] of fixed[code]) {
          const f = Date.UTC(year, month-1, dayOfMonth), wd = new Date(f).getUTCDay();
          if (wd !== 0 && wd !== 6) continue;
          let r = f + DAY;
          while (new Date(r).getUTCDay() === 0 || new Date(r).getUTCDay() === 6 || dates.has(r)) r += DAY;
          dates.add(r);
        }
      }
      if (reportLundi[code]) {
        for (const [month, dayOfMonth] of reportLundi[code]) {
          const f = Date.UTC(year, month-1, dayOfMonth), wd = new Date(f).getUTCDay();
          if (wd === 6) dates.add(f + 2*DAY); else if (wd === 0) dates.add(f + DAY);
        }
      }
      if (code === 'PL' && year >= 2025) dates.add(Date.UTC(year,11,24));
      if (code === 'SE' || code === 'FI') {
        // Veille de la Saint-Jean (midsommarafton, juhannusaatto) : le vendredi du 19 au 25 juin.
        for (let d = 19; d <= 25; d++) if (new Date(Date.UTC(year,5,d)).getUTCDay() === 5) dates.add(Date.UTC(year,5,d));
      }
      if (code === 'NL') {
        const kingsDay = Date.UTC(year,3,27);
        dates.add(new Date(kingsDay).getUTCDay() === 0 ? kingsDay-DAY : kingsDay);
      }
      holidays.set(key,dates);
    }
    return !holidays.get(key).has(day);
  }

  function parisParts(instant) {
    const parts = {};
    for (const part of clock.formatToParts(instant)) {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
    }
    return parts;
  }

  function civilTime(parts) {
    return Date.UTC(parts.year,parts.month-1,parts.day,parts.hour,parts.minute,parts.second);
  }

  function cutoffInstant(day) {
    const target = day + (11*60+30)*60000;
    let instant = target;
    // Convertit 11h30 Paris en instant réel, y compris après un changement d'heure.
    for (let i=0;i<2;i++) instant += target-civilTime(parisParts(new Date(instant)));
    return instant;
  }

  /** @param {{country: string, vendor: string, now?: Date}} options */
  function estimate(options) {
    const now = options.now || new Date();
    const parts = parisParts(now);
    const today = Date.UTC(parts.year,parts.month-1,parts.day);
    const beforeCutoff = parts.hour*60+parts.minute < 11*60+30;
    let dispatch = today;
    if (!beforeCutoff || !businessDay(dispatch,'PL')) {
      do { dispatch += DAY; } while (!businessDay(dispatch,'PL'));
    }
    const country = countryCode(options.country);
    const transit = transitDays(country,options.vendor);
    let delivery = dispatch;
    for (let count=0;count<transit;) {
      delivery += DAY;
      if (businessDay(delivery,country)) count++;
    }
    return {
      dispatchDate: new Date(dispatch), deliveryDate: new Date(delivery), transitDays: transit,
      dispatchDayOffset: (dispatch-today)/DAY, countdownMs: cutoffInstant(dispatch)-now.getTime()
    };
  }

  /** Date du dernier article physique estimé; null pour un panier vide ou virtuel. */
  function estimateCart(options) {
    let latest = null;
    const now = options.now || new Date();
    for (const item of options.items || []) {
      if (item.requires_shipping === false) continue;
      const result = estimate({ now, country: options.country, vendor: item.vendor });
      if (!latest || result.deliveryDate > latest.deliveryDate) latest = result;
    }
    return latest;
  }

  function currentCountry() {
    return countryCode(document.documentElement.getAttribute('data-delivery-country'));
  }

  /* 14/10/2026 · Propriétés de ligne cachées (snippets/casemira-proprietes-ligne.liquid) :
     les champs actifs et remplis d'une racine, en objet { _pictos, _livraison_promise, … }.
     Pour les configurateurs qui ajoutent au panier en JSON (couloir, berbère) ; un
     formulaire produit les envoie de lui-même. Aucun calcul ici : les dates sont celles
     que casemira-delivery-countdown.js a écrites dans les champs avec le bloc affiché. */
  function lineProperties(root) {
    const out = {};
    if (!root || typeof root.querySelectorAll !== 'function') return out;
    for (const field of root.querySelectorAll('input[data-cm-ligne]')) {
      const name = /^properties\[(.+)\]$/.exec(field.name || '');
      if (name && !field.disabled && field.value) out[name[1]] = field.value;
    }
    return out;
  }
  window.CasemiraDelivery = Object.freeze({ estimate, estimateCart, transitDays, currentCountry, lineProperties });
})();
